<section class="relative min-h-screen overflow-hidden bg-[#030f1d]">
  <div class="pointer-events-none absolute inset-0 bg-[rgba(3,15,29,0.55)] backdrop-blur-[2px]">
    <div
      class="absolute -left-24 -top-32 h-[26rem] w-[26rem] rounded-full bg-[rgba(50,97,153,0.35)] blur-[80px]"
    ></div>
    <div
      class="absolute -bottom-28 -right-28 h-[22rem] w-[22rem] rounded-full bg-[rgba(21,64,110,0.3)] blur-[80px]"
    ></div>
  </div>

  <main class="relative z-10 grid min-h-screen place-items-center p-6">
    <div
      class="w-full max-w-[30rem] rounded-2xl border border-[#3f5168] bg-gradient-to-b from-[#212c3a] to-[#1a2330] p-6 shadow-[0_30px_60px_rgba(0,0,0,0.35)] sm:p-9"
    >
      <header class="mb-7 flex flex-col items-center gap-4">
        <div
          class="grid h-14 w-14 place-items-center rounded-xl border border-[#3f5168] bg-[rgba(158,176,197,0.1)] text-2xl"
          aria-hidden="true"
        >
          🔒
        </div>
        <h1 class="m-0 text-center text-4xl leading-tight text-[#eaf1fa] sm:text-[2rem]">
          Admin Login
        </h1>
      </header>

      <app-login-form
        [form]="loginForm"
        [errorMessage]="errorMessage"
        (submitForm)="onSubmit()"
      ></app-login-form>
    </div>
  </main>
</section>
